export const FLIGT_COMPARISON_QUERY_PARAMS = {
  CRID: 'crId',
  X_FLIGHT: 'xflt'
};

export const GI_MMT_CABIN_CLASS_MAP = {
  E: 'E', // Economy
  W: 'PE', // Premium Economy
  B: 'B', // Business
  F: 'F' // First Class
};

export const GI_MMT_FARE_TYPE_MAP = {
  student: 'STU', // Student
  sc: 'SC', // Senior Citizen
  a: 'AF', // Armed Forces
  d: 'DOCTOR' // Doctor and Nurses
};

export const GI_MMT_FARE_TYPE_MAP_NEW = {
  ST: 'STU',
  SC: 'SC',
  AF: 'AF',
  D: 'DOCTOR'
};
